;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import * as Sentry from "@sentry/nextjs";
import { initObservabilityNextjsClient } from "@remi/observability/nextjs-client";

initObservabilityNextjsClient({
  sentry: {
    integrations: [Sentry.browserTracingIntegration(), Sentry.extraErrorDataIntegration()],
  },
});

/** @public */
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
